import React, { useState, useEffect, useRef } from "react";
import Button from "../common/Button/Button";
import { sendOtp, verifyOtp } from "../api/action";
import ToastMsg from "../common/ToastMsg.js";
import { Loader } from "../common/Loader";
import mixpanel from "mixpanel-browser";
import { notifyVisitorEvent } from "../api/action.js";

const OtpInput = ({ mobileNumber, closePopup , userData}) => {
  console.log(userData, "userdatatin props");
  
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const popupRef = useRef(null);
  const [timer, setTimer] = useState(26);
  const [isOtpFilled, setIsOtpFilled] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const timerInterval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timerInterval);
    }
  }, [timer]);
  useEffect(() =>{
    const UserID = localStorage.getItem("UserId")

    const payload = {
      event_name: "Viewed_OTP_screen",
      event_body: {
        "Platform":"m-site",
        },
    };
    
  
  

    notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor button_click Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor button_click event:", error);
    });

    mixpanel.track("Viewed_OTP_screen", {
      "Platform": "m-site",
    });
  }, [])

  const handleBackdropClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      return; 
    }
  };

  const handleVerifyOtp = () => {
    const UserID = localStorage.getItem("UserId")
  
    const payload = {
      event_name: "Interacted_OTP_screen",
      event_body: {
        "Clicked on": "Check eligibility",
            "platform" : "m-site",
        },
    };

 

    notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor button_click Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor button_click event:", error);
    });


    mixpanel.track("Interacted_OTP_screen", {
      "Platform": "m-site",
      "Clicked on": "Check eligibility"
    });
    setLoader(true);
    const otpData = { otp: otp.join("") };

    verifyOtp(otpData)
      .then(() => {
        setLoader(false);
        ToastMsg("OTP verified successfully", "success");
        window.location.href = "/loan-success?otpVerified=true";
      })
      .catch((err) => {
      
        setLoader(false);
        ToastMsg("Incorrect OTP. Please try again.");
      });
  };

  const handleResendOtp = () => {
    const UserID = localStorage.getItem("UserId")
    const payload = {
      event_name: "Interacted_OTP_screen",
      event_body: {
        "Clicked on": "Resend OTP",
            "platform" : "m-site",
        },
    };

  

    notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor button_click Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor button_click event:", error);
    });

    mixpanel.track("Interacted_OTP_screen", {
      "Platform": "m-site",
      "Clicked on": "Resend OTP"
    });

    console.log(userData, "userdatatinsidefunction");
    
    setIsResendDisabled(true);
    setTimer(26);
    setLoader(true);

    sendOtp(userData)
      .then(() => {
        setLoader(false);
        ToastMsg("OTP sent successfully", "success");
      })
      .catch((err) => {
        setLoader(false);
        console.error("Error resending OTP :", err?.message);
      });
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }

    setIsOtpFilled(newOtp.every((digit) => digit !== ""));
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .slice(0, otp.length)
      .replace(/[^0-9]/g, "");
    if (pastedData.length) {
      const newOtp = [...otp];
      for (let i = 0; i < pastedData.length; i++) {
        newOtp[i] = pastedData[i];
      }
      setOtp(newOtp);

      const nextEmptyIndex = pastedData.length;
      if (nextEmptyIndex < otp.length) {
        inputRefs.current[nextEmptyIndex].focus();
      }
    }
  };

  const handleEditClick = () => {
    const UserID = localStorage.getItem("UserId")
   
    const payload = {
      event_name: "Interacted_OTP_screen",
      event_body: {
        "Clicked on": "Edit mobile",
            "platform" : "m-site",
        },
    };
  
    

  

    notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor button_click Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor button_click event:", error);
    });

    mixpanel.track("Interacted_OTP_screen", {
      "Platform": "m-site",
      "Clicked on": "Edit mobile"
    });
    closePopup();
  };

  return (
    <>
      <div className="backdrop" onClick={handleBackdropClick} />

      <div className="otp-popup" ref={popupRef}>
        {loader && <Loader />}
        <h3 className="mb-10">Enter OTP</h3>
        <p className="mb-20">
          Sent To <strong>{mobileNumber}</strong>{" "}
          <span className="edit-link" onClick={handleEditClick}>
            Edit
          </span>
        </p>
        <div className="otp-inputs">
          {otp.map((value, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={value}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleBackspace(e, index)}
              onPaste={handlePaste}
              ref={(el) => (inputRefs.current[index] = el)}
              className={`otp-input ${
                value !== "" || index < otp.findIndex((digit) => digit === "")
                  ? "filled"
                  : ""
              }`}
            />
          ))}
        </div>
        <p className="resend popupTextCenter">
          <span className="didntreceive">Didn’t receive OTP?</span>{" "}
          <span
            className={`resend-link ${isResendDisabled ? "disabled" : ""}`}
            onClick={!isResendDisabled ? handleResendOtp : undefined}
          >
            {timer > 0 ? (
              ` Re-send in 00:${timer < 10 ? `0${timer}` : timer}`
            ) : (
              <span
                style={{
                  color: "#FC6603",
                  textDecoration: "underline",
                  textDecorationColor: "#FC6603",
                  fontWeight: "600",
                }}
              >
                Re-send
              </span>
            )}
          </span>
        </p>

        <div
          className="button-container"
          style={{ opacity: isOtpFilled ? 1 : 0.5 }}
        >
          <Button
            onClick={isOtpFilled ? handleVerifyOtp : undefined}
            sslSecure="false"
            smallsize="true"
            btnName="Check Eligibility"
          />
        </div>
      </div>
    </>
  );
};

export default OtpInput;
